'use client';

import { NavigationMenuDemo } from '@/components/layout/navbar';
import { Footer } from '@/components/layout/footer';
import { COMPANY } from '@/lib/constants';
import { useTranslations } from '@/app/providers';

export default function PrivacyPolicyPage() {
  const t = useTranslations();

  return (
    <>
      <NavigationMenuDemo />
      <main className="min-h-screen pt-32 pb-20">
        <div className="container mx-auto px-6 lg:px-0 max-w-4xl">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {t.privacy.title}
          </h1>
          <p className="text-brand-violet-100 mb-12">{t.privacy.lastUpdate}</p>

          <div className="prose prose-invert prose-lg max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">
                {t.privacy.section1.title}
              </h2>
              <p className="text-slate-300 leading-relaxed">
                {t.privacy.section1.p1}{' '}
                <strong className="text-white">{COMPANY.legalName}</strong>,{' '}
                {t.privacy.section1.p2} {COMPANY.legalAddress},{' '}
                {t.privacy.section1.p3} {COMPANY.vatNumber},{' '}
                {t.privacy.section1.p4} {COMPANY.rea} {t.privacy.section1.p5}
              </p>
              <p className="text-slate-300 leading-relaxed mt-4">
                {t.privacy.section1.p6}{' '}
                <a
                  href={`mailto:${COMPANY.email}`}
                  className="text-brand-violet-300 hover:text-brand-violet-200 underline"
                >
                  {COMPANY.email}
                </a>{' '}
                {t.privacy.section1.p7}{' '}
                <a
                  href={`mailto:${COMPANY.pec}`}
                  className="text-brand-violet-300 hover:text-brand-violet-200 underline"
                >
                  {COMPANY.pec}
                </a>
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">
                {t.privacy.section2.title}
              </h2>
              <p className="text-slate-300 leading-relaxed">
                {t.privacy.section2.intro}
              </p>
              <ul className="list-disc list-inside text-slate-300 mt-4 space-y-2">
                <li>
                  <strong className="text-white">
                    {t.privacy.section2.item1Title}
                  </strong>{' '}
                  {t.privacy.section2.item1Text}
                </li>
                <li>
                  <strong className="text-white">
                    {t.privacy.section2.item2Title}
                  </strong>{' '}
                  {t.privacy.section2.item2Text}
                </li>
                <li>
                  <strong className="text-white">
                    {t.privacy.section2.item3Title}
                  </strong>{' '}
                  {t.privacy.section2.item3Text}{' '}
                  <a
                    href="/cookie"
                    className="text-brand-violet-300 hover:text-brand-violet-200 underline"
                  >
                    Cookie Policy
                  </a>
                  .
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">
                {t.privacy.section3.title}
              </h2>
              <p className="text-slate-300 leading-relaxed">
                {t.privacy.section3.intro}
              </p>
              <ul className="list-disc list-inside text-slate-300 mt-4 space-y-2">
                <li>
                  <strong className="text-white">
                    {t.privacy.section3.item1Title}
                  </strong>{' '}
                  {t.privacy.section3.item1Text}
                </li>
                <li>
                  <strong className="text-white">
                    {t.privacy.section3.item2Title}
                  </strong>{' '}
                  {t.privacy.section3.item2Text}
                </li>
                <li>
                  <strong className="text-white">
                    {t.privacy.section3.item3Title}
                  </strong>{' '}
                  {t.privacy.section3.item3Text}
                </li>
                <li>
                  <strong className="text-white">
                    {t.privacy.section3.item4Title}
                  </strong>{' '}
                  {t.privacy.section3.item4Text}
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">
                {t.privacy.section4.title}
              </h2>
              <p className="text-slate-300 leading-relaxed">
                {t.privacy.section4.intro}
              </p>
              <ul className="list-disc list-inside text-slate-300 mt-4 space-y-2">
                <li>
                  <strong className="text-white">
                    {t.privacy.section4.item1Title}
                  </strong>{' '}
                  {t.privacy.section4.item1Text}
                </li>
                <li>
                  <strong className="text-white">
                    {t.privacy.section4.item2Title}
                  </strong>{' '}
                  {t.privacy.section4.item2Text}
                </li>
                <li>
                  <strong className="text-white">
                    {t.privacy.section4.item3Title}
                  </strong>{' '}
                  {t.privacy.section4.item3Text}
                </li>
                <li>
                  <strong className="text-white">
                    {t.privacy.section4.item4Title}
                  </strong>{' '}
                  {t.privacy.section4.item4Text}
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">
                {t.privacy.section5.title}
              </h2>
              <p className="text-slate-300 leading-relaxed">
                {t.privacy.section5.p1}
              </p>
              <p className="text-slate-300 leading-relaxed mt-4">
                {t.privacy.section5.p2}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">
                {t.privacy.section6.title}
              </h2>
              <p className="text-slate-300 leading-relaxed">
                {t.privacy.section6.intro}
              </p>
              <ul className="list-disc list-inside text-slate-300 mt-4 space-y-2">
                <li>{t.privacy.section6.item1}</li>
                <li>{t.privacy.section6.item2}</li>
              </ul>
              <p className="text-slate-300 leading-relaxed mt-4">
                {t.privacy.section6.p1}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">
                {t.privacy.section7.title}
              </h2>
              <p className="text-slate-300 leading-relaxed">
                {t.privacy.section7.intro}
              </p>
              <ul className="list-disc list-inside text-slate-300 mt-4 space-y-2">
                <li>
                  <strong className="text-white">
                    {t.privacy.section7.item1Title}
                  </strong>{' '}
                  {t.privacy.section7.item1Text}
                </li>
                <li>
                  <strong className="text-white">
                    {t.privacy.section7.item2Title}
                  </strong>{' '}
                  {t.privacy.section7.item2Text}
                </li>
                <li>
                  <strong className="text-white">
                    {t.privacy.section7.item3Title}
                  </strong>{' '}
                  {t.privacy.section7.item3Text}
                </li>
                <li>
                  <strong className="text-white">
                    {t.privacy.section7.item4Title}
                  </strong>{' '}
                  {t.privacy.section7.item4Text}
                </li>
                <li>
                  <strong className="text-white">
                    {t.privacy.section7.item5Title}
                  </strong>{' '}
                  {t.privacy.section7.item5Text}
                </li>
                <li>
                  <strong className="text-white">
                    {t.privacy.section7.item6Title}
                  </strong>{' '}
                  {t.privacy.section7.item6Text}
                </li>
                <li>
                  <strong className="text-white">
                    {t.privacy.section7.item7Title}
                  </strong>{' '}
                  {t.privacy.section7.item7Text}
                </li>
              </ul>
              <p className="text-slate-300 leading-relaxed mt-4">
                {t.privacy.section7.p1}{' '}
                <a
                  href={`mailto:${COMPANY.email}`}
                  className="text-brand-violet-300 hover:text-brand-violet-200 underline"
                >
                  {COMPANY.email}
                </a>
                .
              </p>
              <p className="text-slate-300 leading-relaxed mt-4">
                {t.privacy.section7.p2} (
                <a
                  href="https://www.garanteprivacy.it"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-brand-violet-300 hover:text-brand-violet-200 underline"
                >
                  www.garanteprivacy.it
                </a>
                ).
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">
                {t.privacy.section8.title}
              </h2>
              <p className="text-slate-300 leading-relaxed">
                {t.privacy.section8.p1}
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
